"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderMenuNotifications = HeaderMenuNotifications;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const streamline_icon_alarm_bell_1_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-alarm-bell-1.svg"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const types_1 = require("@src/types");
const Api = __importStar(require("@src/api"));
const socket_context_1 = require("@src/context/socket-context");
const notification_context_1 = require("@src/context/notification-context");
const react_intl_1 = require("react-intl");
const Notifications_1 = require("./Notifications");
const HeaderMenuNotifications_style_1 = require("./HeaderMenuNotifications.style");
const HeaderMenu_style_1 = require("./HeaderMenu.style");
function HeaderMenuNotifications({ setActiveCategory, onCategoryLeave, isActive }) {
    const NotificationContext = (0, notification_context_1.useNotificationContextValue)();
    const notifications = react_1.default.useMemo(() => NotificationContext.notifications, [NotificationContext.notifications]);
    const { pageStats, newNotificationsCount, loadMoreNotifications, getNotifications } = NotificationContext;
    const [mounted, setMounted] = react_1.default.useState(false);
    const notificationsColumnRef = react_1.default.useRef(null);
    const socket = (0, socket_context_1.useSocket)();
    const [loading, setLoading] = react_1.default.useState(false);
    const hasUnreadNotifications = react_1.default.useMemo(() => notifications.some(n => !n.seen_at), [notifications]);
    const init = react_1.default.useCallback(async () => {
        try {
            setLoading(true);
            getNotifications();
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    }, []);
    const watchNotifications = async () => {
        try {
            if (hasUnreadNotifications) {
                await Api.Account.watchAllNotifications();
                await init();
            }
        }
        catch (err) {
            console.error(err);
        }
    };
    react_1.default.useEffect(() => {
        setMounted(true);
        socket.on(types_1.SocketEvents.NOTIFICATION_RECEIVED, init);
        init();
        return () => {
            socket.off(types_1.SocketEvents.NOTIFICATION_RECEIVED, init);
        };
    }, []);
    react_1.default.useEffect(() => {
        if (isActive) {
            watchNotifications();
        }
    }, [isActive]);
    const onScroll = e => {
        const { scrollTop, scrollHeight, clientHeight } = notificationsColumnRef.current;
        const bottomLoadingTrasholdInPixels = 20;
        if (scrollTop + clientHeight >= scrollHeight - bottomLoadingTrasholdInPixels) {
            loadMoreNotifications();
        }
        e.preventDefault();
    };
    const debouncedOnScrollLoad = (0, debounce_1.default)(onScroll, 50);
    react_1.default.useEffect(() => {
        if (!loading && pageStats.page < pageStats.pageCount) {
            ;
            notificationsColumnRef.current.addEventListener('scroll', debouncedOnScrollLoad);
            return () => { var _a; return (_a = notificationsColumnRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', debouncedOnScrollLoad); };
        }
    }, [pageStats, loading]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(HeaderMenuNotifications_style_1.UserNotifications, { active: hasUnreadNotifications, onMouseEnter: () => setActiveCategory({ category: 'notifications', offset: '0' }), onMouseLeave: onCategoryLeave, children: [(0, jsx_runtime_1.jsx)(HeaderMenu_style_1.MenuLabelWrapper, { to: "#", active: isActive, hasContent: Boolean(notifications.length), children: (0, jsx_runtime_1.jsx)(streamline_icon_alarm_bell_1_svg_1.default, { viewBox: "0 0 24 24" }) }), (0, jsx_runtime_1.jsx)(HeaderMenu_style_1.MenuContent, { mounted: mounted, visible: isActive, userControls: true, ref: notificationsColumnRef, children: (0, jsx_runtime_1.jsx)(HeaderMenu_style_1.MenuContentColumn, { children: (0, jsx_runtime_1.jsxs)(HeaderMenu_style_1.MenuContentInner, { width: 350, children: [(0, jsx_runtime_1.jsx)(Notifications_1.Notifications, { notifications: notifications, refetchNotifications: init, isLoading: loading, skeletonCount: newNotificationsCount }), pageStats.pageCount > pageStats.page && !loading && ((0, jsx_runtime_1.jsx)(HeaderMenu_style_1.LoadMore, { onClick: loadMoreNotifications, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.notifications.load_more" }) }))] }) }) })] }) }));
}
